var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "gallery-imgs",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "10",
      "order-xl": "2"
    }
  }, [_c('div', {
    staticClass: "pl-xl-20"
  }, [_c('div', {
    staticClass: "gallery-imgs__img"
  }, [_c('v-tabs-items', {
    attrs: {
      "value": _vm.selectedIndex
    }
  }, _vm._l(_vm.imgs, function (img, index) {
    return _c('v-tab-item', {
      key: img._id,
      attrs: {
        "value": index
      }
    }, [_c('auction-imgs-overlay', {
      attrs: {
        "imgs": _vm.imgs
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref) {
          var attrs = _ref.attrs,
              on = _ref.on,
              setIndex = _ref.setIndex;
          return [_c('v-img', _vm._g(_vm._b({
            staticClass: "grey-ef",
            attrs: {
              "contain": "",
              "src": img.url,
              "aspect-ratio": 1 / 1,
              "width": "100%",
              "max-width": "540px"
            },
            on: {
              "click": function click($event) {
                return setIndex(img);
              }
            }
          }, 'v-img', attrs, false), on))];
        }
      }], null, true)
    })], 1);
  }), 1)], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "2",
      "order-xl": "1"
    }
  }, [_c('div', {
    staticClass: "gallery-imgs__thumb-wrap"
  }, _vm._l(_vm.imgs, function (img, index) {
    return _c('div', {
      key: img._id,
      staticClass: "gallery-imgs__thumb",
      class: {
        'active': _vm.selectedIndex == index
      },
      on: {
        "mouseenter": function mouseenter($event) {
          return _vm.setSelectedIndex(img);
        }
      }
    }, [_c('v-img', {
      staticClass: "grey-ef",
      attrs: {
        "contain": "",
        "src": img.url,
        "aspect-ratio": 1 / 1,
        "width": "100%"
      }
    })], 1);
  }), 0)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }